import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../base";

function FormRadioInputPreview({ ...props }) {
  return <BasePreview {...props}>
    <input type="radio" />
  </BasePreview>
}

export default define('form-radio-input', FormRadioInputPreview, Fragment)
  .shared(prop.share('FormRadioInput', 'form-radio-input'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .build()

